import { AppRemixIcon } from '@/layout/AppComponents';
import { useDispatch, useSelector } from 'react-redux';
import * as currentPageAction from '../../../../../../store/actions/currentPageAction';

export default function ResourceCheckbox({
  elementID,
  resourceObligationID,
}) {
  const dispatch = useDispatch();
  const checkedResources = useSelector(
    (state) => state.currentPage?.checkedResources?.[elementID]
  );

  // > TOGGLE RESOURCE CHECKBOX
  const toggleCheckbox = async () => {
    const tempCheckedResources = !checkedResources ? [] : [...checkedResources];

    if (tempCheckedResources?.includes(resourceObligationID)) {
        dispatch(
          currentPageAction.change(
            'checkedResources',
            {
              [elementID]: tempCheckedResources.filter(
                (tcr) => tcr !== resourceObligationID
              ),
            },
            true
          )
        );
      } else {
        tempCheckedResources.push(resourceObligationID);
        dispatch(
          currentPageAction.change(
            'checkedResources',
            { [elementID]: tempCheckedResources },
            true
          )
        );
      }
  };
  // < TOGGLE RESOURCE CHECKBOX

  return (
    <>
      <AppRemixIcon
        className="pointer"
        icon={
          checkedResources?.includes(resourceObligationID)
            ? 'checkbox'
            : 'checkbox-blank'
        }
        size={20}
        onClick={toggleCheckbox}
      />
    </>
  );
}
